import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";

const ReceiptCostitemListComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [receiptCostitems, setReceiptCostitems] = useState([]);
  const receiptId = props?.receiptId ?? props?.initialValues?.id ?? id;
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [costStatuses, setCostStatuses] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    if (!receiptId) return;
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      const receiptFilter = `search[receipt][operator]==&search[receipt][value]=${Number(receiptId)}`;
      const joinChar = query.includes('?') ? '&' : '?';
      apiCall('get', '/api/v2/cost-allocation' + query + joinChar + receiptFilter)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setReceiptCostitems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const formatCurrency = (value, currencyCode) => {
    const currency = currencyCode;
    return window.App?.currencyFormatter
      ? window.App.currencyFormatter(currency, value)
      : <>{Number(value || 0)}&nbsp;{currency}</>;
  };

  const totalAmount = useMemo(() => {
    return (receiptCostitems || []).reduce((sum, row) => sum + Number(row?.amount || 0), 0);
  }, [receiptCostitems]);

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer={t('grandTotal')} colSpan={5} footerStyle={{textAlign: 'right', fontWeight: 600}} />
        <Column footer={formatCurrency(totalAmount, receiptCostitems[0]?.currency)} footerStyle={{textAlign: 'left', fontWeight: 700}} />
      </Row>
    </ColumnGroup>
  );

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }


  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'receipt-costitem'){
  //                     history.push('/finance/receipt-costitem/update/' + rowData.id)
  //                   }else{
  //                     history.push('/finance/receipt/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/cost-item/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderReceiptCostitemList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/cost-status')
      .then(response => {
        const d = response.data?.data || response.data;
        const list = Array.isArray(d) ? d : (d?.data || []);
        setCostStatuses(list || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderReceiptCostitemList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={receiptCostitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                 footerColumnGroup={footerGroup}
      >
        <Column field="cost_item.name" header={t('columnName')} sortable filter></Column>
        <Column field="cost_type.name" header={t('columnCostType')} sortable filter body={(rowData) => 
          (rowData?.cost_type?.name) + ' (' + ((rowData?.cost_type?.acronym) + ')')}>

        </Column>
        <Column field="cost_center.name" header={t('columnCostCenter')} sortable filter body={(rowData) =>
          (rowData?.cost_center?.name) + ' (' + ((rowData?.cost_center?.code) + ')')
        }></Column>
        <Column field="cost_item.source" header={t('columnCostSource')} body={(rowData) => {
          const source = rowData?.cost_item?.source;
          return source ? t(`costSource${source}`) : '';
        }}></Column>
        <Column field="approved_by.name" header={t('columnApproved')} sortable filter body={(rowData) => {
          const name = rowData?.approved_by?.name;
          const at = rowData?.approved_at;
          if (!name || !at) return '';
          return `${name} (${at})`;
        }}></Column>
        {/* <Column field="status" header={t('columnStatus2')} sortable filter filterMatchMode="equals" 
          body={(rowData) => {
            const key = rowData?.status;
            const found = costStatuses?.find(x => x.key === key);
            return <>{found?.value || key || ''}</>;
          }}
          filterElement={(options) => (
            <Dropdown
              value={options.value}
              options={costStatuses}
              optionLabel="value"
              optionValue="key"
              placeholder={t('selectPlaceholder')}
              showClear
              onChange={(e) => options.filterApplyCallback(e.value)}
              appendTo={document.body}
            />
          )}
        /> */}
        <Column field="amount" header={t('columnAmount')} sortable body={(rowData) => (
            <>
              {formatCurrency(rowData?.amount, rowData?.currency)}
            </>
          )}
        />
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ReceiptCostitemListComponent);
